module.exports = __webpack_public_path__ + "static/media/2S.67c7a5fd.svg";